"use strict";

exports.__esModule = true;
var _Collection = require("./Collection");
Object.keys(_Collection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Collection[key]) return;
  exports[key] = _Collection[key];
});
var _CollectionGetter = require("./CollectionGetter");
Object.keys(_CollectionGetter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CollectionGetter[key]) return;
  exports[key] = _CollectionGetter[key];
});
var _CollectionSearcher = require("./CollectionSearcher");
Object.keys(_CollectionSearcher).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CollectionSearcher[key]) return;
  exports[key] = _CollectionSearcher[key];
});